<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Play from 'assets/images/play.svg?component'
import { logInteraction } from '@bosca/analytics-client-browser'
import type { Video } from '~/utils/generated/graphql'
import type { ContentItemTypes } from '~/utils/graphql/graphql'
import { addPlayerEvents } from '~/utils/playerevents'

const props = defineProps<{
  item: ContentItemTypes | undefined
  video: Video | undefined
  vertical?: boolean
  onPlay?: (() => void) | undefined
}>()

const overlayVisible = ref(true)

const poster = props.video?.poster?.url
  ? props.video?.poster?.url
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
  : props.item?.media
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
    ? props.item?.media[0]?.sources[0]?.url
    : null

const $player = ref<HTMLElement>()
let player: Plyr | null = null

function onPause() {
  player?.pause()
}

onMounted(() => {
  if (typeof window === 'undefined') return
  window.addEventListener('pause-player', onPause)
})

onUnmounted(() => {
  if (typeof window === 'undefined') return
  window.removeEventListener('pause-player', onPause)
})

async function createPlayer() {
  import('plyr/dist/plyr.css')
  const Plyr = (await import('plyr')).default
  player = new Plyr($player.value!, {
    ratio: props.vertical ? '9:16' : '16:9',
    autoplay: true,
    muted: true,
    youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, autoplay: 1, playsinline: 1 },
  })
  addPlayerEvents(player, false, props.item, props.onPlay, overlayVisible)
}

watch($player, () => {
  if ($player.value && typeof $player.value.checkVisibility === 'function' && $player.value.checkVisibility()) {
    if (player) player.destroy()
    createPlayer()
  }
})

function onOverlayClick() {
  if (!player) createPlayer()
  overlayVisible.value = false
  if (player?.playing) {
    player?.restart()
  }
  else {
    player?.play()
  }
  logInteraction({
    id: 'play',
    type: 'button',
    content: props.item
      ? [{ id: props.item.id || '', type: props.item.__typename || '' }]
      : [],
    extras: { audio: (!props.video).toString() },
  })
}
</script>

<template>
  <div :class="'w-full h-full relative ' + (vertical ? 'vertical-player' : 'player') + (overlayVisible ? ' overlayed' : '')">
    <div
      ref="$player"
      class="plyr w-full h-full"
      data-plyr-provider="youtube"
      :data-plyr-embed-id="video?.youtube"
      :poster="poster"
    />
    <div
      v-if="overlayVisible"
      class="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 cursor-pointer"
      @click="onOverlayClick"
    >
      <div class="w-full h-full justify-center flex content-center">
        <Play class="w-8 h-8 md:w-16 md:h-16 self-center" />
      </div>
    </div>
  </div>
</template>

<style>
.overlayed .plyr__controls { display: none }

.plyr {
  min-width: 100px !important;
  min-height: 100px !important;
}
</style>
